import { cx } from "../../utils/classNames";
import ui from "./ui.module.css";

const TONE_CLASSES = {
  gray: ui.toneGray,
  amber: ui.toneAmber,
  green: ui.toneGreen,
  red: ui.toneRed,
  blue: ui.toneBlue,
  purple: ui.tonePurple,
};

// Colours shared by every review workflow (DTR, leave, …).
const STATUS_TONES = {
  SUBMITTED: "amber",
  PENDING: "amber",
  APPROVED: "green",
  REJECTED: "red",
  CANCELLED: "gray",
};

const Badge = ({ tone = "gray", icon, children }) => (
  <span className={cx(ui.badge, TONE_CLASSES[tone])}>
    {icon && <i className={`bi ${icon}`}></i>}
    {children}
  </span>
);

// `status` null/undefined renders as gray (e.g. "Not submitted").
export const StatusBadge = ({ status, labels = {}, emptyLabel = "—" }) => (
  <Badge tone={STATUS_TONES[status] ?? "gray"}>
    {status ? (labels[status] ?? status) : emptyLabel}
  </Badge>
);

export default Badge;
